import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateRange from 'SF/date/DateRange';
import { IntakeSerializedDateFormat } from 'intake/intakeTypes';
import { SFEntityID, UndefinedNullType, dateInFormat } from 'utils/types';
import { isEqual } from 'lodash';

export default class DateRangeFilterPanel extends React.Component {
  static propTypes = {
    value: PropTypes.shape({
      start: PropTypes.oneOfType([dateInFormat(IntakeSerializedDateFormat), UndefinedNullType]),
      end: PropTypes.oneOfType([dateInFormat(IntakeSerializedDateFormat), UndefinedNullType])
    }),

    question: PropTypes.shape({
      id: SFEntityID.isRequired,
      options: PropTypes.array,
      text: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }),

    enabled: PropTypes.bool,
    granularity: PropTypes.oneOf(['month', 'day']).isRequired,

    onSubmit: PropTypes.func,
    addSelection: PropTypes.func.isRequired,
    removeSelection: PropTypes.func.isRequired
  };

  static defaultProps = {
    granularity: 'day',
    enabled: true,

    value: {
      start: null,
      end: null
    }
  };

  shouldComponentUpdate(nextProps) {
    return !isEqual(nextProps, this.props);
  }

  onDatesChange = ({startDate, endDate}) => {
    this.props.addSelection({
      questionId: this.props.question.id,
      type: this.props.question.type,
      value: {
        start: startDate.format(IntakeSerializedDateFormat),
        end: endDate.format(IntakeSerializedDateFormat)
      }
    })
  };

  onInvalidChange = () => {
    this.props.removeSelection(this.props.question.id)
  };

  render() {
    const date = serializedDate => serializedDate && moment(serializedDate, IntakeSerializedDateFormat) || null;
    const existingValue = this.props.value || {};

    return (
      <DateRange
        granularity={this.props.granularity}
        numberOfMonths={1}
        numberOfYears={1}
        screenReaderInputMessage=""
        startDate={date(existingValue.start)}
        endDate={date(existingValue.end)}
        disabled={!this.props.enabled}
        onDatesChange={this.onDatesChange}
        onInvalidChange={this.onInvalidChange} />
    );
  }
}
